import React from 'react';
import { Hero } from '../components/Hero';
import { Legacy } from '../components/Legacy';
import { CompetencyGrid } from '../components/CompetencyGrid';
import { StrategicMap } from '../components/StrategicMap';
import { CapabilityStatement } from '../components/CapabilityStatement';
export function Home() {
  return <>
      <Hero data-id="element-435" />
      <Legacy data-id="element-436" />
      <CompetencyGrid data-id="element-437" />
      <StrategicMap data-id="element-438" />
      <CapabilityStatement data-id="element-439" />
    </>;
}